(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rf-bestseller-circles"] && !Shopify.designMode) return;
  try {
    (() => {
  const setup = () => {
    const root = document.getElementById('rf-bestseller-circles');
    if (!root || root.dataset.ready) return;
    root.dataset.ready = 'true';
    const track = root.querySelector('.rf-circle-track');
    const toggle = root.querySelector('[data-toggle]');
    const previous = root.querySelector('[data-previous]');
    const next = root.querySelector('[data-next]');
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    let paused = reduced.matches, hovered = false, focused = false, visible = true;
    let position = track.scrollLeft, direction = 1, last = 0, edgeUntil = 0;
    const max = () => Math.max(0, track.scrollWidth - track.clientWidth);
    const label = () => {
      toggle.hidden = reduced.matches;
      toggle.textContent = paused ? toggle.dataset.play : toggle.dataset.pause;
      toggle.setAttribute('aria-label', toggle.textContent);
    };
    const manual = () => { paused = true; position = track.scrollLeft; label(); };
    toggle.addEventListener('click', event => { paused = !paused; position = track.scrollLeft; edgeUntil = 0; label(); if (!paused && event.detail > 0) toggle.blur(); });
    previous.addEventListener('click', () => { manual(); track.scrollBy({left:-Math.max(96,track.clientWidth * .75),behavior:reduced.matches ? 'instant' : 'smooth'}); });
    next.addEventListener('click', () => { manual(); track.scrollBy({left:Math.max(96,track.clientWidth * .75),behavior:reduced.matches ? 'instant' : 'smooth'}); });
    root.addEventListener('mouseenter', () => { hovered = true; });
    root.addEventListener('mouseleave', () => { hovered = false; position = track.scrollLeft; });
    root.addEventListener('focusin', () => { focused = true; });
    root.addEventListener('focusout', () => { requestAnimationFrame(() => { focused = root.contains(document.activeElement); position = track.scrollLeft; }); });
    track.addEventListener('pointerdown', manual, {passive:true});
    track.addEventListener('touchstart', manual, {passive:true});
    track.addEventListener('wheel', manual, {passive:true});
    track.addEventListener('keydown', manual);
    reduced.addEventListener('change', () => { if (reduced.matches) manual(); });
    const observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; });
    observer.observe(root);
    const step = now => {
      if (!root.isConnected) { observer.disconnect(); return; }
      const elapsed = last ? Math.min(now-last,50) : 0;
      last = now;
      const limit = max();
      previous.disabled = limit < 1 || track.scrollLeft < 1;
      next.disabled = limit < 1 || track.scrollLeft >= limit - 1;
      if (!paused && !hovered && !focused && visible && !document.hidden && !reduced.matches && limit > 0 && now >= edgeUntil) {
        position = Math.max(0,Math.min(limit,position + direction * Number(root.dataset.speed) * elapsed / 1000));
        track.scrollLeft = position;
        if (position >= limit || position <= 0) { direction *= -1; edgeUntil = now + 1800; }
      } else { position = track.scrollLeft; }
      requestAnimationFrame(step);
    };
    root.querySelector('.rf-circle-controls').hidden = false;
    label();
    requestAnimationFrame(step);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',setup); else setup();
  document.addEventListener('shopify:section:load',setup);
})();
  } catch(e) { console.error(e); }
})();

})();
